import { makeStyles, TableCell, TableRow } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

export default function AtsApiTableCell({ columns, element, index }) {
  const classes = useStyles();

  const elementValue = element;

  return (
    <TableRow
      hover
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={index}
      component={Link}
      to={{ pathname: "/inboundfeeds/atsapidetailed", state: element }}
    >
      {columns.map((column, elementIndex) => (
        <TableCell align="left" key={elementIndex}>
          {elementValue[column.propName]}
        </TableCell>
      ))}
    </TableRow>
  );
}
